const styleSheet = () => ({
  uncheckedColumns: {
    '&:hover': {
      cursor: 'default',
    },
    '& .column': {
      marginLeft: '37px',
      marginBottom: '9px',
      height: '20px',
    },
    '& .columnName': {
      height: '15px',
      width: '173px',
      color: '#6373A4',
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '15px',
      verticalAlign: 'top',
      marginLeft: '10px',
      userSelect: 'none',
    },
  },
  divider: {
    height: '1px',
    width: '220px',
    borderTop: '10px',
    margin: '20px auto',
    backgroundColor: 'lightgrey',
  },
  settingsContainer: {
    display: 'inline-block',
    cursor: 'pointer',
    position: 'absolute',
    zIndex: '12',
    textAlign: 'left !important',
    textTransform: 'initial',
    top: '-8.5px',
    right: '0.5%',
    userSelect: 'none',
  },
  icon: {
    display: 'inline-block',
    width: '14px',
  },
  iconContainer: {
    position: 'relative',
    float: 'right',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    height: '24px',
    width: '24px',
    border: 0,
    borderRadius: '4px',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export default styleSheet;
